<template>
  <widget-content :bg="model.background" :mobile-bg="model.mobileBackground" :style="storeStyle" class="store-widget-wrap">
    <div :class="titleBackgroundClass" class="flex justify-center store-title-rich-wrap">
      <rich-text
        v-if="model.titleVisible"
        v-model="model.title"
        :class="$store.getters.isDesktop ? 'text-[40px]' : 'text-[22px]'"
        :disabled="!editing"
        :editing="editing"
        :family.sync="model.titleFamily"
        :stroke.sync="model.titleStroke"
        :exclude="['font-size']"
        class="w-full title"
        placement="bottom"
        theme="snow"
      />
    </div>
    <div
      v-if="isShowLayoutBtn"
      class="store-menu__icon"
      @click="infoMenuVisible = !infoMenuVisible"
    >
      <InfoMenuIcon v-if="infoMenuVisible"/>
      <i v-else class="el-icon-menu"></i>
    </div>
    <div v-if="isShowStoreNav" class="nav-container relative">
      <div class="nav-wrap relative">
        <div ref="group-tab-all" class="nav-wrap__item" @click="handleShowAllGoods">
          {{ $t('siteBuild.all') }}
        </div>
        <div
          v-for="(item, index) in groupList"
          :key="index"
          :ref="`group-tab-${index}`"
          :style="groupNameStyle"
          class="nav-wrap__item"
          @click="handleChangeClassify(item, index)"
        >
          <div>{{ item.group.name }}</div>
        </div>
        <div class="line" :style="lineStyle" />
      </div>
    </div>
    <bg-style
      v-for="(item, index) in currentGoodsList"
      :id="`group-${item.group.id}`"
      :key="index"
      :bg="item.background"
      class="store-item"
      :class="{ empty: !(item.data && item.data.length), '!pb-0': index === currentGoodsList.length - 1 }"
    >
      <div v-if="model.groupNameVisible" class="group-name">
        <span :style="groupNameStyle">
          {{ item.group.name }}
        </span>
      </div>
      <div ref="store" class="store-goods-wrap">
        <div class="store-goods">
          <OneGood
            v-for="(good, goodIndex) in item?.data"
            :key="goodIndex"
            :editing="editing"
            :good="good"
            :info-menu-visible="infoMenuVisible"
            :is-last-one="index === item.data.length - 1"
            :is-mobile="isMobile"
            :model="model"
            :show-car="showCar"
            :store-lang="storeLang"
            @buy="buy"
            @show-detail="onShowDetail(good)"
          />
          <template v-if="editing && !item?.data?.length">
            <OneGood
              v-for="good in 4"
              :key="good"
              :editing="editing"
              :good="{names: good, activities: [], id: good}"
              :info-menu-visible="infoMenuVisible"
              :is-mobile="isMobile"
              :model="model"
              :show-car="showCar"
              :store-lang="storeLang"
              is-tmp
              @show-detail="onShowDetail(good)"
            />
          </template>
        </div>
      </div>
    </bg-style>
    <payresult v-model="showpayresult" :device="device" @close="showpayresult = false" />
    <DeskPayModal
      v-if="deskPay.visible"
      :desk-pay="deskPay"
      :lang-id-data="langIdData"
      :order-data="orderData"
      :store-lang="storeLang"
      @close="closePayModal"
    />
    <goods-detail ref="detail" :good="currentGoods" :is-mobile="isMobile" :model="model" :store-lang="storeLang" @buy="buy"/>
  </widget-content>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import tinycolor from 'tinycolor2'
import isNil from 'lodash.isnil'
import cloneDeep from 'lodash.clonedeep'
import {Message} from 'element-ui'
import OneGood from './oneGood/index.vue'
import GoodsDetail from './detail.vue'
import tools, {checkIgnoreMessage, getLangIdI18n} from '~/utils'
import { getIpInfo } from "~/site/core";
import WidgetContent from '~/site/components/widgetContent'
import payresult from '~/components/pay/payresult.vue'
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import Bus, {emitWinBus} from '~/site/model/bus'
import richText from '~/components/richText'
import {isMobile} from '~/utils/types'
import {GET_SITE_ID, default_site_lang, PAY_URL, isBuildWebSite, isPre} from '~/config'
import InfoMenuIcon from '~/assets/svg/icon/info-menu.svg?inline'
import {DeviceEnum} from '~/enums/deviceEnum'
import {getTitleBackgroundClass} from '~/utils/dom'

let isPreviewMode = !isBuildWebSite
let isSandBox = !isBuildWebSite
const SiteID = GET_SITE_ID()
// eslint-disable-next-line no-console
if (isBuildWebSite && isPre && SiteID.startsWith('56') && SiteID.length === 2) {
  // myCard验收商城
  isSandBox = isPreviewMode = true
}

export default {
  name: 'StoreWidgetEdit',
  components: {
    richText,
    GoodsDetail,
    payresult,
    WidgetContent,
    OneGood,
    InfoMenuIcon,
    DeskPayModal
  },

  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    editing: {
      type: Boolean,
      default: false,
    },
    device: {
      type: String,
      default: 'desktop',
    },
  },
  data() {
    return {
      loading: false,
      currentGroup: 0,
      currentGoods: null,
      that: this,
      lang: tools.getLang(this),
      copyStores: [],
      groupList: [],
      lineWidth: 0,
      lineLeft: 0,
      titleBackgroundClass: '',
      storeLang: default_site_lang,
      showpayresult: false,
      currencies: [],
      currencieMap: null,
      pushing: false, //  加购中
      return_url: '', // 支付返回地址
      infoMenuVisible: true,
      creating: false,
      // PC端支付弹框
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      },
      orderData: {}
    }
  },
  computed: {
    ...mapState({
      realDevice: (state) => state.device.device,
      userInfo: (state) => state.user.siteUserInfo,
      projectInfo: (state) => state.project.info.project,
      projectId: (state) => state.project.projectId,
      isUpdateUuid: state => state.user.isUpdateUuid,
      langIdData: state => state.locale.langIdData,
      shopGood: state => state.site.shopGood
    }),
    titleText() {
      const res = this.model.layout.find((m) => {
        return m.key === 'storeTitle'
      })
      return res && res.titleText
    },
    currentGoodsList() {
      return this.currentGroup === 0 ? this.groupList : [this.groupList.find(item => item.group.id === this.currentGroup)]
    },
    lineStyle() {
      return {
        width: this.lineWidth + 'px',
        left: this.lineLeft + 'px'
      }
    },
    showCar() {
      const res = this.model.layout.find((m) => {
        return m.key === 'car'
      })
      return res && res.value
    },
    groupNameStyle() {
      if (this.model?.groupNameColorShow) {
        return {
          color: this.model.groupNameColor,
        }
      }
      return {}
    },

    isMobile() {
      const device = this.editing
        ? this.device
        : this.realDevice
      return device === DeviceEnum.MOBILE
    },
    isShowLayoutBtn() {
      const hasGoods = this.model?.stores.some(store => !!store?.__goods?.length)
      const isNormalGoodLayout = this.model.goodsLayoutMethod === 'normal'
      return this.isMobile && hasGoods && isNormalGoodLayout
    },
    isShowStoreNav() {
      return this.model?.stores?.length > 1
    },
    priceOpacityColor() {
      const color = tinycolor(this.model.goodsPriceColor)
      color.setAlpha(0.8)
      return color.toRgbString()
    },
    priceOpacity50() {
      const color = tinycolor(this.model.goodsPriceColor)
      color.setAlpha(0.5)
      return color.toRgbString()
    },
    storeStyle() {
      const nameColor = tinycolor(this.model.goodsTitleColor)
      return {
        '--price-opacity-color': this.priceOpacityColor,
        '--price-color-50': this.priceOpacity50,
        '--goods-name-color': this.model.goodsTitleColorShow ? nameColor.toRgbString() : null,
        '--goods-name-color30': this.model.goodsTitleColorShow ? nameColor.setAlpha(0.7).toRgbString() : null
      }
    }
  },
  async created() {
    this.storeLang = tools.getStoreLang(this)

    // 获取货币列
    await this.getCurrencies()

    // 获取商品信息
    this.pushing = (!this.isUpdateUuid && !this.editing)
    await this.getAllGoodsList()
    await this.initShopCart()

  },
  mounted() {
    this.titleBackgroundClass = getTitleBackgroundClass()
    this.copyStores = cloneDeep(this.model.stores)
    this.handleShowAllGoods()
    Bus.$on('updateGood', (sitem, gitem) => {
      this.handleShowAllGoods()
      this.getAllGoodsList()
    })

    Bus.$on('reloadGood', async (type) => {
      if (type === 'login-out') {
        this.$store.commit('site/SET_SHOP_GOOD', null)
      }
      if (type === 'login') {
        this.checkBuy()
      }
      await getIpInfo(this)
      this.handleShowAllGoods()
      await this.getAllGoodsList()
      await this.getShopCart(this)
    })

    // 检查是否是支付页面跳转回来的
    this.checkStatus()
    this.return_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?from=${this.$route.query.from}`
  },
  destroyed() {
    Bus.$off('updateGood')
    Bus.$off('reloadGood')
  },
  methods: {
    handleShowAllGoods() {
      this.currentGroup = 0
      const $tab = this.$refs['group-tab-all']
      if (!$tab) return
      this.lineWidth = $tab.offsetWidth
      this.lineLeft = $tab.offsetLeft
    },
    handleChangeClassify(item, index) {
      this.currentGroup = item.group.id
      const $tab = this.$refs[`group-tab-${index}`][0]
      this.lineWidth = $tab.offsetWidth
      this.lineLeft = $tab.offsetLeft
    },
    ...mapMutations({
      'SET_STORE_GOODS': 'site/SET_STORE_GOODS'
    }),
    ...mapActions({
      'getShopCart': 'goods/getShopCart'
    }),
    async getAllGoodsList() {
      const projectInfo = this.$store.state.project
      const params = {
        merchant_id: projectInfo.merchantId,
        project_id: projectInfo.projectId,
        group_id: this.model.stores.map(item => item.select[1].value)?.join(','),
        enabled: 1
      }
      if (!params.group_id) {
        const emptyTemplate = [{ group: {} }]
        this.groupList = this.editing ? emptyTemplate : []
        return
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.good.getAllGoodsList(params, this.editing))
      this.loading = false
      if (!err) {
        const data = res?.data?.filter(item => item.group.enabled) || []
        this.groupList = data.map(item => {
          const newItem = {...item}
          newItem.group.name = getLangIdI18n(item.group.names, this.$store.state.locale.langIdData)
          newItem.data.forEach(goodsItem => {
            goodsItem.activity_rule = JSON.parse(goodsItem.activity_rule || '{}')
          })
          return newItem
        })
        this.emitWinBusInit()
      } else {
        Message.error(err)
      }
    },
    onShowDetail(good) {
      if (this.editing || !good) return
      this.currentGoods = cloneDeep(good)
      this.$refs.detail.init()
    },
    async initShopCart() {
      if (this.editing || !this.$store.state.user.siteLoginUserInfo) return
      await this.getShopCart(this)
    },
    emitWinBusInit() {
      this.$nextTick(() => {
        emitWinBus('goods-init', this.$refs.store)
      })
    },
    // 获取商品信息
    // async getGoods(params, s, editing) {
    //   if (!params.group_id) {
    //     this.pushing = false
    //     return
    //   }
    //   const [err, result] = await this.$utils.to(this.$api.good.getVirtualItems(params, {editing}))
    //   this.pushing = false
    //   if (!err && result) {
    //     if (result?.discount_info?.discount_level) {
    //       this.$store.commit('goods/SET_DISCOUNT_INFO', cloneDeep(result.discount_info))
    //     }
    //     const groupEnabled = result.group && result.group.enabled
    //     const data = groupEnabled ? result.data.map(item => {
    //       const newItem = {...item}
    //       newItem.activity_rule = JSON.parse(newItem.activity_rule || '{}')
    //       return newItem
    //     }) : []
    //     const tempGoods = data ? data.filter((item) => item.enabled) : []
    //     this.$set(s, '__goods', tempGoods)
    //     this.SET_STORE_GOODS(cloneDeep(this.model.stores))
    //     const names = result?.group?.names || {}
    //     const {lang_id} = names
    //     const groupName = lang_id ? (this.langIdData[lang_id] || lang_id) : names[this.storeLang]
    //     this.$set(s, '__groupName', groupName || '')
    //     this.emitWinBusInit()
    //   } else {
    //     this.$imessage({
    //       content: err?.message || err,
    //       type: 'warning',
    //     })
    //   }
    // },
    checkBuy() {
      this.shopGood && this.createOrder(cloneDeep(this.shopGood))
    },
    // 购买
    buy(good) {
      if (this.editing) return
      if (isNil(this.userInfo?.id)) {
        this.$store.commit('site/SET_SHOP_GOOD', cloneDeep(good))
        this.$store.commit('user/SET_LOGINSHOW', !this.editing)
        this.$store.commit('user/SET_SITE_BIND_USER', true)
        this.$refs.detail.cancel()
        return
      }
      this.createOrder(good)
    },
    createOrder(good) {
      if (this.creating || !good?.id) return
      this.creating = true
      const StoreIpInfo = tools.getLangByip(this)
      const {currency} = StoreIpInfo
      const {
        project_id,
        merchant_id
      } = this.userInfo
      let ipInfo = {}
      try {
        ipInfo = tools.getxfip(localStorage)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
      const priceInfo = tools.getPriceInfo(good.prices_setting, StoreIpInfo, this);
      const price = +priceInfo.price;
      const device = isMobile() ? 'mobile' : 'desktop'
      const lang = tools.getNeedParamsFormRouteParams(this.$route.params)?.lang || 'en'
      const sandbox = isSandBox ? 1 : 0  //  true : false
      const params = {
        project_id,
        merchant_id,
        currency,
        amount: price,
        from_preview_mode: isPreviewMode,
        items: [
          {
            item_id: good.id,
            num: 1,
            amount: price,
            price,
            currency,
            virtual_currency: currency,
            virtual_currency_amount: price,
          },
        ],
        settings: {
          view_source: this.$route.query.from,
          device,
          language: lang,
          show_order: false,
          return_url: this.return_url,
        },
      }
      this.orderData = cloneDeep(params)
      this.$api.order.createOrder(params, ipInfo).then((res) => {
        if (res.token) {
          this.openPayModal(res, sandbox, device)
        }
      }).catch((err) => {
        !checkIgnoreMessage(err) && Message.error(err)
      })
        .finally(() => {
          this.creating = false
        })
    },
    // open pay modal PC
    openPayModal(res, sandbox, device) {
      const {token, code} = res
      let payUrl = ''
      const env = process.env.RUN_ENV
      const isGoPay = token.slice(0, 2) === 'v2'
      if (isGoPay) {
        payUrl = `${PAY_URL[env]}/new-kop/payelement?access_token=${token}&sandbox=${+sandbox}`
      } else {
        payUrl = `${PAY_URL[env]}/pay/payelement?access_token=${token}&sandbox=${+sandbox}`
      }
      if (device === 'mobile') {
        this.$store.commit('site/SHOW_ORDER_MODAL', {code, payUrl})
      } else {
        this.deskPay = {
          visible: true,
          isGoPay,
          payUrl,
          orderCode: code
        }
      }
    },
    closeDetail() {
      this.$refs.detail.cancel()
    },
    closePayModal() {
      this.closeDetail()
      this.$store.commit('site/SET_SHOP_GOOD', null)
      this.getAllGoodsList()
      Bus.$emit('reloadActivity', 'payment')
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    },
    checkStatus() {
      const paymentId = ''
      if (paymentId) {
        if (!tools.getQueryString('isHide')) {
          if (window.showpayresult) return
          this.showpayresult = Boolean(paymentId)
          window.showpayresult = true
        }
      }
    },

    // 获取货币列表
    async getCurrencies() {
      const res = await this.$api.common.getCurrencies()
      this.currencies = res.data
      this.currencieMap = {}
      this.currencies.forEach((c) => {
        this.currencieMap[c.id] = c
      })
      this.$store.commit('project/SET_CURRENCYINFO', {
        currency: this.currencies,
        currencieMap: this.currencieMap,
      })
    },
    // scrollGoodGroup(group, index) {
    //   this.currentGroup = index
    //   scrollTo(`${this.model.id}-group-${group.key}`, 'site-body', 50)
    // }
  },
}
</script>

<style lang="less" scoped>
.normal-goods {
  column-gap: 32px;
}

.store-widget-wrap {
  position: relative;
  background-size: 100%;
  padding: 60px 0 40px 0;
  overflow: hidden;

  .nav {
    &-container {
      width: 100%;
      margin-bottom: 46px;
    }

    &-wrap {
      @apply flex items-center justify-center;
      width: max-content;
      margin: 0 auto;
      column-gap: 60px;
      .line {
        height: 4px;
        background-color: var(--button-background-color);
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 2px;
        width: 84px;
        transition: all 0.24s ease-in-out;
      }
      &__item {
        cursor: pointer;
        position: relative;
        white-space: nowrap;
        font-size: 18px;
        padding-bottom: 15px;
      }
    }
  }

  .back-color-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .store-title-rich-wrap {
    position: relative;
    margin-bottom: 50px;
  }

  .store-item {
    padding: 0 0 36px 0;
    position: relative;
    background-size: 100%;
    min-height: 300px;
    &:last-child {
      padding-bottom: 0;
    }
    .back-color-wrap {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .group-name {
      text-align: center;
      position: relative;
      margin-bottom: 40px;

      span {
        font-size: 26px;
        color: var(--text-color-alpha-06);
      }
    }

    .store-goods-wrap {
      display: flex;
      justify-content: center;

      .store-goods {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
    }

    &.empty {
      min-height: auto;
      padding: 0 !important;
    }
  }

  .x-auto {
    overflow-x: auto;
    overflow-y: hidden;
  }

  // 兼容线上环境样式丢失
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }
}

.site-device-750 {
  .store-title-rich-wrap {
    margin-bottom: 24px;
  }

  .nav {
    &-container {
      width: 100%;
      margin-bottom: 10px;
    }

    &-wrap {
    @apply flex items-center justify-center;
      column-gap: 30px;

      &__item {
      @apply cursor-pointer;
        font-size: 12px;
      }
    }
  }

  .store-widget-wrap {
    min-width: auto;
    padding: 40px 0 40px 0;

    .store-title-rich-wrap {
      .title-rich {
        .ql-toolbar.ql-snow {
          top: 0;
        }
      }
    }

    .store-item {
      padding: 12px 0 16px 0;

      &:last-child {
        padding-bottom: 0;
      }

      .group-name {
        margin: 8px 0 16px;

        span {
        @apply text-16;
        }
      }

      .store-goods-wrap {
        .store-goods {
        @apply w-full overflow-hidden mb-5;
          column-gap: 0;
          padding: 0;

          &:last-child {
          @apply mb-0;
          }
        }
      }
    }
  }
}

.store-menu__icon {
  position: absolute;
  top: 5px;
  right: 10px;
  width: 20px;
  height: 20px;
  font-size: 20px;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }
}
</style>
<style lang="less">
.store-widget-wrap {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: revert !important;
  }
}
</style>
